var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loginUser.classData==0)?_c('notJoinClass',{attrs:{"loginUser":_vm.loginUser},on:{"updateUserInfo":_vm.updateUserInfo}}):_vm._e(),(_vm.loginUser.classData==1)?_c('joinClass',{attrs:{"loginUser":_vm.loginUser}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }